export function pipe<T>(...fns: Array<(x: any) => any>): (x: T) => any {
  if (fns.length === 0) {
    return (x) => x;
  }

  for (const fn of fns) {
    if (typeof fn !== 'function') {
      throw new Error('All pipe arguments should be functions');
    }
  }

  return (x: T) => fns.reduce((value, fn) => fn(value), x);
}
